import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=4be80fa1&scoped=true&"
import script from "./PriceBox.vue?vue&type=script&lang=js&"
export * from "./PriceBox.vue?vue&type=script&lang=js&"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=4be80fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be80fa1",
  null
  
)

export default component.exports